module.exports = __webpack_public_path__ + "static/Block Fencing-55410cc35ceb2003ecdbb60dcca1d3b1.jpg";